import type * as Brink from 'types/vendors/brink'

export function useLastRawCart() {
  const lastRawCart = useState<Brink.Cart | undefined>('lastRawCart', () => (undefined))

  return { lastRawCart }
}
